import { useRouter } from 'next/router';

import { FormField, FormHelp, Label, Select } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { useScreenSize } from '../../../hooks';
import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { usePropertyEditMutation } from '../../../hooks/usePropertyEditMutation';
import { bathOptions } from '../../../constants/ListingDetailsConstants';

const inputName = 'numBathrooms';

const BathroomsFormField = () => {
  const router = useRouter();
  const { isScreenDesktop } = useScreenSize();

  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const floorPlans = listingDetails?.floorPlans || [];
  const floorPlanId = floorPlans[0]?.id;
  const initialBathrooms = floorPlans[0]?.numBathrooms;

  let bathOptionsValues = bathOptions;

  if (initialBathrooms !== undefined) {
    bathOptionsValues = bathOptions.slice(1);
  }

  const updateMutation = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms,
  });

  const bathroomsField = useFieldSave({
    fieldName: inputName,
    initialValue: initialBathrooms,
    mutation: updateMutation,
    buildMutationVariables: (value) => ({
      getParams: { floorPlanId: floorPlanId!, numBathrooms: Number(value) },
    }),
  });

  return (
    <FormField
      data-testid="BathroomsFormField"
      required={true}
      label={<Label>Total bathrooms</Label>}
      control={
        <Select
          size={isScreenDesktop ? 'lg' : 'md'}
          name={inputName}
          value={String(bathroomsField.value)}
          onChange={(e) => bathroomsField.onChange(Number(e.target.value))}
          onBlur={bathroomsField.onBlur}
          required={true}
          css={{ whiteSpace: 'pre' }}
        >
          {bathOptionsValues.map((option) => {
            if (option === '10+') {
              return (
                <option key={option} value={10}>
                  {option}
                </option>
              );
            }
            return (
              <option key={option} value={option}>
                {option}
              </option>
            );
          })}
        </Select>
      }
      error={!!bathroomsField.error}
      description={<FormHelp>{bathroomsField.error}</FormHelp>}
    />
  );
};

export default BathroomsFormField;
